import { useState } from "react";
import { Check, Loader2, Pencil, RotateCcw } from "lucide-react";
import { fullName, primaryLine, secondaryLine } from "../lib/doorGuests";

const CheckedIn = () => (
  <span data-testid="door-row-checked-in" className="inline-flex min-h-[48px] items-center gap-1.5 rounded-xl bg-emerald-50 px-3 text-sm font-bold text-emerald-700">
    <Check className="h-5 w-5" strokeWidth={3} /> Checked in
  </span>
);

const UndoControl = ({ onUndo, disabled }) => {
  const [confirming, setConfirming] = useState(false);
  if (!confirming) {
    return (
      <button type="button" data-testid="door-row-undo" disabled={disabled} onClick={() => setConfirming(true)} className="inline-flex min-h-[40px] items-center gap-1 rounded-lg px-2 text-xs font-semibold text-slate-500 hover:bg-slate-100 disabled:opacity-50">
        <RotateCcw className="h-3.5 w-3.5" /> Undo check-in
      </button>
    );
  }
  return (
    <span className="inline-flex items-center gap-1">
      <span className="text-xs font-semibold text-slate-600">Undo check-in?</span>
      <button type="button" data-testid="door-row-undo-confirm" onClick={() => { setConfirming(false); onUndo(); }} className="min-h-[40px] rounded-lg bg-slate-900 px-3 text-xs font-semibold text-white">Yes, undo</button>
      <button type="button" data-testid="door-row-undo-cancel" onClick={() => setConfirming(false)} className="min-h-[40px] rounded-lg px-2 text-xs font-semibold text-slate-500">Keep</button>
    </span>
  );
};

export const DoorRow = ({ guest, pending, error, onCheckIn, onUndo, onRetry, onNames }) => {
  const name = fullName(guest);
  const second = secondaryLine(guest);
  return (
    <li data-testid={`door-row-${guest.id}`} className="border-b border-slate-100 px-4 py-3">
      <div className="flex items-center gap-3">
        <div className="min-w-0 flex-1">
          <p data-testid="door-row-identifier" className="break-words text-base font-semibold text-slate-900">{primaryLine(guest)}</p>
          {second && <p data-testid="door-row-name" className="break-words text-sm text-slate-500">{second}</p>}
          <div className="mt-1 flex flex-wrap items-center gap-1">
            <button type="button" data-testid="door-row-names-btn" onClick={onNames} className="inline-flex min-h-[40px] items-center gap-1 rounded-lg px-2 text-xs font-semibold text-blue-700 hover:bg-blue-50">
              <Pencil className="h-3.5 w-3.5" /> {name ? "Edit name" : "Add name"}
            </button>
            {guest.checked_in && <UndoControl onUndo={onUndo} disabled={!!pending} />}
          </div>
        </div>
        {pending ? (
          <span data-testid="door-row-pending" className="inline-flex min-h-[48px] min-w-[7.5rem] items-center justify-center gap-2 rounded-xl bg-slate-100 px-4 text-sm font-semibold text-slate-500">
            <Loader2 className="h-4 w-4 animate-spin" /> Saving…
          </span>
        ) : guest.checked_in ? (
          <CheckedIn />
        ) : (
          <button type="button" data-testid="door-row-check-in" onClick={onCheckIn} className="min-h-[48px] min-w-[7.5rem] rounded-xl bg-blue-700 px-4 text-base font-bold text-white shadow-sm transition-transform duration-150 active:scale-95">
            Check in
          </button>
        )}
      </div>
      {error && (
        <div data-testid="door-row-error" role="alert" className="mt-2 flex items-center justify-between gap-3 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
          <span>{error}</span>
          <button type="button" data-testid="door-row-retry" onClick={onRetry} className="min-h-[40px] rounded-lg bg-red-600 px-3 text-sm font-semibold text-white">Retry</button>
        </div>
      )}
    </li>
  );
};
